import { useMutation } from '@apollo/client';
import { UpdateLlmProviderConfigDocument, useGetLlmProviderConfigLazyQuery as _useGetLlmProviderConfigLazyQuery, useGetLlmProviderConfigQuery as _useGetLlmProviderConfigQuery, useGetLlmProviderModelsLazyQuery as _useGetLlmProviderModelsLazyQuery, useGetLlmProvidersQuery as _useGetLlmProvidersQuery, } from '../generated/graphql-types';
export const useGetLlmProvidersQuery = () => {
    const { data, loading, error } = _useGetLlmProvidersQuery({
        variables: {},
    });
    return {
        error,
        loading,
        data: data?.Admin_getLLMProviders?.Data,
    };
};
export const useGetLlmProviderModelsLazyQuery = (name) => {
    const [getLlmProviderModels, { data, loading, error },] = _useGetLlmProviderModelsLazyQuery({
        variables: { providerName: name },
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data,
        getLlmProviderModels,
    };
};
export const useUpdateLlmProviderConfigMutation = () => {
    const [_updateLlmProviderConfigMutation, { data, loading, error },] = useMutation(UpdateLlmProviderConfigDocument);
    return {
        error,
        loading,
        data,
        updateLlmProviderConfigMutation: (providerName, configChanges, onSuccess, onError) => _updateLlmProviderConfigMutation({
            variables: {
                providerName,
                configChanges,
            },
            onCompleted: data => {
                if (onSuccess)
                    onSuccess();
            },
            onError: err => {
                onError?.(err);
            },
        }),
    };
};
export const useGetLlmProviderConfigQuery = (providerName) => {
    const { data, loading, error } = _useGetLlmProviderConfigQuery({
        variables: {
            providerName,
        },
    });
    return {
        error,
        loading,
        data,
    };
};
export const useGetLlmProviderConfigLazyQuery = (providerName) => {
    const [getLlmProviderConfig, { data, loading, error },] = _useGetLlmProviderConfigLazyQuery({
        variables: { providerName },
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data,
        getLlmProviderConfig,
    };
};
//# sourceMappingURL=llm-service.js.map